module.exports = __webpack_public_path__ + "img/h_dog_pt_cone_setsku.prt.e470b29c.jpg";